module.exports = __webpack_public_path__ + "static/docsBackMobile@2x-697be924da319f1f545bef44eef23823.png";